import { SOURCE_SCHEMA_API_URL } from './sourceSchemaEnum.js';
import createService from 'shared/utils/createService.js';

export default createService(SOURCE_SCHEMA_API_URL, {
  extraMethods: {
    async get(id, { tables, refresh, ...config } = {}) {
      const hasTables = Array.isArray(tables);
      const requestConfig = hasTables
        ? {
            url: `${this.route}${id}/schema-collection/`,
            method: 'post',
            data: { tables, ...(refresh !== undefined ? { refresh } : {}) },
            ...config,
          }
        : {
            url: `${this.route}${id}/schema-collection/`,
            ...config,
          };
      // POST requests need the CSRF token in prod (GET passes through
      // safe-method exemption); set it here since we bypass the `this.request`
      // wrapper that would normally attach it.
      this.setCSRFTokenInRequestConfig(requestConfig);
      let response;
      let error;
      let errorCode = null;
      try {
        response = await this.axiosInstance.request(requestConfig);
      } catch (err) {
        const detail = err?.response?.data?.detail;
        errorCode = detail?.code ?? null;
        error = detail?.message || detail || err?.message || 'Network error';
      }
      if (response?.data) {
        return { id, collections: response.data, error: null, errorCode: null };
      }
      return { id, collections: {}, error, errorCode };
    },
    async getColumns(id, name, config = {}) {
      const response = await this.axiosInstance.request({
        url: `${this.route}${id}/schema-collection-columns/${name}`,
        ...config,
      });
      return response;
    },
  },
});
